export const OPEN_ONCE = `
    mutation open_once_by_station_or_entrance($data: openOnceInput!) {
        open_once_by_station_or_entrance (data: $data) {
            success
            errorText
        }
    }
`

export const CLEAN_RELAY = `
    mutation clean_relay_by_station($data: cleanRelayInput!) {
        clean_relay_by_station (data: $data) {
            success
            errorText
        }
    }
`

export const SET_STATION_RESTRICTED_NOW = `
    mutation SetStationRestrictedNow($station_id: Float!, $client_id: Float!, $value: Boolean!) {
        set_station_restricted_now(station_id: $station_id, client_id: $client_id, value: $value) {
            success
            errorText
            data {
                id
                extra
            }
        }
    }
`
